import { render, staticRenderFns } from "./SaveFilterModal.vue?vue&type=template&id=0b983c14&scoped=true&lang=html&"
import script from "./SaveFilterModal.vue?vue&type=script&lang=ts&"
export * from "./SaveFilterModal.vue?vue&type=script&lang=ts&"
import style0 from "./SaveFilterModal.vue?vue&type=style&index=0&id=0b983c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b983c14",
  null
  
)

export default component.exports